import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6cc1694f")

_pushScopeId("data-v-6cc1694f")
const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "input-field" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "reset-password__form__action" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Field = _resolveComponent("Field")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")
  const _component_Alert = _resolveComponent("Alert")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      (_ctx.state.code)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            class: "reset-password__form",
            onSubmit: _ctx.resetPassword
          }, {
            default: _withId(({ errors }) => [
              _createVNode("h2", null, _toDisplayString(_ctx.t('reset password')), 1),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.data.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.email = $event)),
                  name: "email",
                  rules: "required|email"
                }, {
                  default: _withId(({ field }) => [
                    _createVNode(_component_InputText, _mergeProps({
                      id: "email",
                      type: "text",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => (field.value = $event)
                    }, field, {
                      class: { 'p-invalid': errors.email },
                      placeholder: _ctx.t('email'),
                      "aria-placeholder": _ctx.t('email')
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder", "aria-placeholder"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "p-error"
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.data.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.password = $event)),
                  name: "password",
                  rules: "required|password"
                }, {
                  default: _withId(({ field }) => [
                    _createVNode(_component_InputText, _mergeProps({
                      id: "password",
                      type: "password",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => (field.value = $event)
                    }, field, {
                      class: { 'p-invalid': errors.password },
                      placeholder: _ctx.t('new password')
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "password",
                      class: "p-error"
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.data.passwordConfirm,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.passwordConfirm = $event)),
                  name: "passwordConfirm",
                  rules: "required|confirmed:@password"
                }, {
                  default: _withId(({ field }) => [
                    _createVNode(_component_InputText, _mergeProps({
                      id: "passwordConfirm",
                      type: "password",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => (field.value = $event)
                    }, field, {
                      class: { 'p-invalid': errors.passwordConfirm },
                      placeholder: _ctx.t('confirm new password')
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "passwordConfirm",
                      class: "p-error"
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Button, {
                  type: "submit",
                  class: "-button -royalBlue"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('change')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[4] || (_cache[4] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[5] || (_cache[5] = ($event: any) => (_ctx.alert.content = ''))
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true)
    ])
  ]))
})